const numberFormat = (number, locale = "en-EN", options = {}) => {
  return new Intl.NumberFormat(locale, options).format(number);
};

export default numberFormat;
